import { render } from "./NavigationMenu.vue?vue&type=template&id=ce53f206&scoped=true&ts=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts"

import "./NavigationMenu.vue?vue&type=style&index=0&id=ce53f206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce53f206"]])

export default __exports__